import React, { FC } from 'react';
import styles from '../SelectTemplateStep.scss';
import { useAppStore } from 'stores/state';
import { templates } from 'config/templates';
import { SitePreview } from 'components/SitePreview/SitePreview';
import { templateUtils } from 'utils/templates';

export const SelectTemplateStepPreview: FC = () => {
  const templateSlug = useAppStore((state) => state.templateSlug);
  const template = templateSlug ? templates[templateSlug] : undefined;
  const mobileImageSrc = template ? templateUtils.getAssetUrl(template.assets.mobile) : undefined;

  return template && mobileImageSrc ? (
    <div className={styles.selectTemplateStepPreview}>
      <SitePreview url={template.siteUrl} mobileImageSrc={mobileImageSrc} />
    </div>
  ) : null;
};
